module.exports = __webpack_public_path__ + "media/theme/border-3-43680e8a.png";